import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ForWho = lazy(() => import('./components/ForWho').then(m => ({
  default: m.ForWho
})));
const NotForYou = lazy(() => import('./components/NotForYou').then(m => ({
  default: m.NotForYou
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const PreviewImages = lazy(() => import('./components/PreviewImages').then(m => ({
  default: m.PreviewImages
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const ValueCalculator = lazy(() => import('./components/ValueCalculator').then(m => ({
  default: m.ValueCalculator
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Aggressively defer Meta Pixel - only after 5 seconds or user interaction
    if (typeof window !== 'undefined') {
      let pixelLoaded = false;
      const loadPixel = () => {
        if (!pixelLoaded) {
          pixelLoaded = true;
          // Use requestIdleCallback for even lower priority
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initMetaPixel(), {
              timeout: 2000
            });
          } else {
            setTimeout(initMetaPixel, 100);
          }
        }
      };
      // Load on user interaction or after 5 seconds
      const events = ['scroll', 'click', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, loadPixel, {
          once: true,
          passive: true
        });
      });
      const timeout = setTimeout(loadPixel, 5000);
      return () => {
        events.forEach(event => window.removeEventListener(event, loadPixel));
        clearTimeout(timeout);
      };
    }
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text font-body selection:bg-brand-cta selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />

      <Suspense fallback={null} data-id="element-2">
        <PainPoints data-id="element-3" />
        <ForWho data-id="element-4" />
        <NotForYou data-id="element-5" />
        <Benefits data-id="element-6" />
        <SocialProof data-id="element-7" />
        <ContentOverview data-id="element-8" />
        <Bonuses data-id="element-9" />
        <PreviewImages data-id="element-10" />
        <Pricing data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <ValueCalculator data-id="element-14" />
        <Footer data-id="element-15" />
      </Suspense>
    </div>;
}